/*eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setIs404Error } from 'src/redux/app/appSlice';
import { PageNotFoundSVG } from '../Member/img/ServerErrorSVG';
import PublicHeader from '../Member/components/header/PublicHeader';
import PublicFooter from '../Member/components/footer/PublicFooter';
import './PageNotFound.scss';

const PageNotFound = ({ pathname, validateUrl, from, redirectTo = '/' }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  const { isLoggedIn } = useSelector((state) => state.user);
  const [isInsideSubRoute, SetIsInsideSubRoute] = useState(false);

  useEffect(() => {
    console.log('***************************');
    console.log(from);
    if (from !== undefined) {
      if (from === 'member' || from === 'admin') {
        SetIsInsideSubRoute(true);
      }
    }

    if (validateUrl === true) {
      const isInValidUrl = isInValidRootUrl(pathname);
      setIsError(isInValidUrl);
      dispatch(setIs404Error(isInValidUrl));
    } else {
      setIsError(true);
    }
  }, [pathname]);

  const isInValidRootUrl = (pathname) => {
    const testMember = pathname.match(/\/member/);
    const testMemberWithSlash = pathname.match(/\/member\//);
    const testAdmin = pathname.match(/\/admin/);
    const testAdminWithSlash = pathname.match(/\/admin\//);
    let isInvalidUrl = false;

    if (
      !testMember &&
      !testAdmin &&
      !testMemberWithSlash &&
      !testAdminWithSlash
    ) {
      isInvalidUrl = true;
    } else if (pathname.match(/\/member\/admin/)) {
      isInvalidUrl = true;
    } else {
      if (testAdmin && testMember) {
        if (testMemberWithSlash && pathname[7] !== '/' && pathname[7]) {
          isInvalidUrl = true;
        }
        if (testAdminWithSlash && pathname[6] !== '/' && pathname[6]) {
          isInvalidUrl = true;
        }
      } else if (
        testMember &&
        !testAdmin &&
        pathname[7] !== '/' &&
        pathname[7]
      ) {
        isInvalidUrl = true;
      } else if (
        testAdmin &&
        !testMember &&
        pathname[6] !== '/' &&
        pathname[6]
      ) {
        isInvalidUrl = true;
      }
    }
    return isInvalidUrl;
  };

  return isError ? (
    <div className="member">
      {!isLoggedIn && !isInsideSubRoute && <PublicHeader />}
      <Container className="page-not-found">
        <Row>
          <Col className="text-center no-data-found-component">
            <div className="page-not-found-container">
              <PageNotFoundSVG />
              <div className="content-box">
                <h1 role="alert">Page Not Found</h1>
                <p role="alert">
                  {`We can’t find the page you're looking for. <br />
                  You can either return to the previous page, visit our
                  dashboard <br />
                  or contact our support team.${' '}`}
                </p>
                <Link
                  to={redirectTo}
                  className={'login-btn text-center w-auto'}
                >
                  {`Go to ${isLoggedIn ? 'Dashboard' : 'Homepage'}`}
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      {!isLoggedIn && !isInsideSubRoute && <PublicFooter />}
    </div>
  ) : null;
};

export default PageNotFound;
